export const ADD_SUBJECT_REQUEST = 'subjects/ADD_SUBJECT_REQUEST'
export const SET_SUBJECTS = 'subjects/SET_SUBJECTS'
export const SET_IS_FETCHING_SUBJECTS = 'subjects/SET_IS_FETCHING_SUBJECTS'
export const RESET_IS_FETCHING_SUBJECTS = 'subjects/RESET_IS_FETCHING_SUBJECTS'
export const CLEAR_SUBJECTS = 'subjects/CLEAR_SUBJECTS'
export const GET_SUBJECTS_REQUEST = 'subjects/GET_SUBJECTS_REQUEST'
export const SET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE = 'subjects/SET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE'
export const RESET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE = 'subjects/RESET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE'
export const DEACTIVATE_SUBJECT_REQUEST = 'subjects/DEACTIVATE_SUBJECT_REQUEST'
export const REACTIVATE_SUBJECT_REQUEST = 'subjects/REACTIVATE_SUBJECT_REQUEST'
export const CREATE_PRESCRIPTION_REQUEST = 'subjects/CREATE_PRESCRIPTION_REQUEST'
export const UPDATE_PRESCRIPTION_REQUEST = 'subjects/UPDATE_PRESCRIPTION_REQUEST'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/subjects/actionTypes.ts